import React from 'react';
import { ProductQandAContainer } from './ProductQandAContainer';

export const BundleQuestionsContainer = () => <ProductQandAContainer />;
